var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("v-card-title", [
        _c("span", { staticClass: "headline" }, [_vm._v("Share")])
      ]),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-container",
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Add Collaborator(s)",
                          placeholder: "Enter an email address",
                          type: "text",
                          clearable: "",
                          "append-outer-icon": "add"
                        },
                        on: {
                          "click:append-outer": _vm.addCollab,
                          keyup: _vm.addCollabOnEnter
                        },
                        model: {
                          value: _vm.email.address,
                          callback: function($$v) {
                            _vm.$set(_vm.email, "address", $$v)
                          },
                          expression: "email.address"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.error.length > 0,
                      expression: "error.length > 0"
                    }
                  ],
                  attrs: { id: "error-message" }
                },
                [_vm._v(" " + _vm._s(_vm.error) + " ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.emails, function(item, index) {
                return _c(
                  "span",
                  { key: index },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { depressed: "", small: "" },
                        on: {
                          click: function($event) {
                            return _vm.removeCollab(index)
                          },
                          mouseover: function($event) {
                            return _vm.mouseOver(item)
                          },
                          mouseleave: function($event) {
                            return _vm.mouseLeave(item)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.address) +
                            "\n            "
                        ),
                        _c(
                          "v-icon",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.isActive,
                                expression: "item.isActive"
                              }
                            ],
                            attrs: { dark: "", right: "" }
                          },
                          [_vm._v(" clear ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-card-actions", [_c("v-spacer")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a7c7aa6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a7c7aa6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/shareAssetCard.vue
// module id = null
// module chunks = 